import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import documentationActions from 'actions/documentationActions';
import preLoaderActions from 'actions/preLoaderActions';
import DocumentRetryRequestModal from 'components/DocumentRetryRequestModal';
import DocumentRetryThanksModal from 'components/DocumentRetryThanksModal';
import standByActions from 'actions/standByActions';
import { GetDocumentationView } from './GetDocumentationView/GetDocumentationView';
import { useDocumentationStatus } from './hooks/useDocumentationStatus';
import { useDocumentationRetry } from './hooks/useDocumentationRetry';
import buildTagging from './tagging';
import DocumentationViewContextProvider from './context/DocumentationViewContext/DocumentationViewContext';
import withFeatureToggling from '../../../hocs/withFeatureToggling/withFeatureToggling';
import { DOCUMENT_TYPES, DOCUMENTS_TO_BE_CAPTURED } from 'constants/documents';
import { isDesktop } from 'utilities/browser';
import { CLIENT_RISK } from 'constants/clientRisk';
import { isCountrySpain } from 'utilities/multiLanguageHelper';
import { ROBO, TRADITIONAL } from 'constants/userProfile';
import { ACTIVITY_DATA_TGSS } from 'constants/featureFlagging';
import { setPageName } from 'actions/errorViewNavigation';

const DocumentationViewComponent = ({
    userProfile,
    preLoaderActions,
    documentationActions,
    actions,
    products,
    immStepsState,
    documentation,
    formActions: { change },
    flags,
    setPageName,
}) => {
    const isTagDocumentationFired = useRef(false);
    const isTagStandbyFired = useRef(false);
    const { status, investmentType, clientRisk, tgssWasChecked } = userProfile;
    const [isDocumentRetryBeenShown, setIsDocumentRetryBeenShown] = useState(false);

    const filesToUpload = documentation.get('filesToUpload');

    const getShouldShowTgssConsent = () => {
        const isTraditionalOrRoboUser = investmentType === TRADITIONAL || investmentType === ROBO;

        return (
            Boolean(filesToUpload.find(({ docId }) => docId === DOCUMENT_TYPES.DAAL)) &&
            flags.get(ACTIVITY_DATA_TGSS) &&
            isCountrySpain &&
            isTraditionalOrRoboUser &&
            clientRisk === CLIENT_RISK.MEDIUM &&
            !tgssWasChecked
        );
    };

    const shouldShowTgssConsent = getShouldShowTgssConsent();
    const shouldShowQRPage = filesToUpload.find(({ docId }) => DOCUMENTS_TO_BE_CAPTURED.includes(docId)) && isDesktop();

    const {
        doTagGetInformationDocumentError,
        doTagDocumentRetryThanksClose,
        doTagDocumentRetryDocClose,
        doTagDocumentationPage,
        doTagRecordStandByPage,
        doTagDocumentRetry,
        doTagModalDocumentationRetry,
    } = buildTagging({
        isTagDocumentationFired,
        isTagStandbyFired,
        userProfile,
        products,
        immStepsState,
        documentation,
        shouldShowTgssConsent,
        shouldShowQRPage,
    });

    const { isDocumentationUploaded, isDocumentationLoaded } = useDocumentationStatus({
        actions,
        change,
        doTagGetInformationDocumentError,
        doTagDocumentationPage,
        doTagRecordStandByPage,
        documentationActions,
        preLoaderActions,
        userProfile,
        isDocumentRetryBeenShown,
        setPageName,
    });

    const {
        isDocumentRetry,
        isDocumentRetryRequestVisible,
        isDocumentRetryThanksVisible,
        handleDocumentRetryDocClose,
        handleDocumentRetryThanksClose,
    } = useDocumentationRetry({
        actions,
        doTagDocumentRetry,
        doTagDocumentRetryDocClose,
        doTagDocumentRetryThanksClose,
        doTagModalDocumentationRetry,
        isDocumentationLoaded,
        isDocumentationUploaded,
        userProfile,
        setIsDocumentRetryBeenShown,
        isDocumentRetryBeenShown,
    });

    return (
        <DocumentationViewContextProvider
            shouldShowTgssConsent={shouldShowTgssConsent}
            shouldShowQRPage={shouldShowQRPage}
            isDocumentRetryBeenShown={isDocumentRetryBeenShown}
        >
            <DocumentRetryRequestModal
                onClose={handleDocumentRetryDocClose}
                modalIsOpen={isDocumentRetryRequestVisible}
            />
            <DocumentRetryThanksModal
                onClose={handleDocumentRetryThanksClose}
                modalIsOpen={isDocumentRetryThanksVisible}
            />
            <GetDocumentationView
                status={status}
                isDocumentationUploaded={isDocumentationUploaded}
                isDocumentationLoaded={isDocumentationLoaded}
                isDocumentRetry={isDocumentRetry}
                isDocumentRetryBeenShown={isDocumentRetryBeenShown}
            />
        </DocumentationViewContextProvider>
    );
};

const mapStateToProps = state => ({
    immStepsState: state.steps,
    userProfile: state.userProfile,
    products: state.products,
    documentation: state.documentation,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(stepsActions, dispatch),
    standByActions: bindActionCreators(standByActions, dispatch),
    documentationActions: bindActionCreators(documentationActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    setPageName: bindActionCreators(setPageName, dispatch),
});

export const DocumentationView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withFeatureToggling(DocumentationViewComponent));
